// extracted by mini-css-extract-plugin
module.exports = {"cells":"columns_cells__1tOZy"};